import '../assets/sass/Main.scss';

import Accessibility from "./Accessibility"
import StartScreen from "./StartScreen"
import SVGExport from "./SVGExport"
import Content from "./Content/Content"
import OnMobileDevice from "./OnMobileDevice"
import Settings from "../noncomponents/Settings"


import { useState, useLayoutEffect } from 'react';

function App() {

  const [size, setSize] = useState([0, 0]);
	useLayoutEffect(() => {
		function updateSize() {
			setSize([
				document.documentElement.clientWidth,
				document.documentElement.clientHeight
			]);
		}
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);

  if(size[0] < 700){
    return (
      <OnMobileDevice />
    )
  }

	const settings = Settings(size);


  return (
    <div className="App">

      {/* <TitlePanel />*/}

      <Accessibility />

      <StartScreen />

      <SVGExport />

      <Content settings={settings} />


    </div>
  );
}

export default App;
